import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { catchError } from 'rxjs/internal/operators/catchError';
import { CommonService } from 'src/app/shared/services/common-service';
import { environment } from 'src/environments/environment';
import { LiberatePrescriptionRequest } from '../../requests/orchestrator-patient/liberate-prescription.request';
import { ListMedicalPrescriptionEpisodeResponse } from '../../responses/medical-record/list-medical-prescription-episode.response';
import { LiberateSolutionPrescriptionRequest } from '../../requests/orchestrator-patient/liberate-solution-prescription.request';
import { MedicationDispensingHistoryResponse } from '../../responses/medical-record/medication-dispensing-history.response';
import { MedicationDispensingHistoryRequest } from '../../requests/orchestrator-patient/medication-dispensing-history.request';
import { EpisodePrescriptionToPharmacyPrescriptionReleaseResponse } from '../../responses/orchestrator-patient/episode-prescription-to-pharmacy-prescription-release.response';
import { ListPharmacyPrescriptionResponse } from '../../responses/orchestrator-patient/list-pharmacy-prescription.response';
import { MaterialDispensingHistoryResponse } from '../../responses/medical-record/material-dispensing-history.response';
import { MaterialDispensingHistoryRequest } from '../../requests/orchestrator-patient/material-dispensing-history.request';

@Injectable({
  providedIn: 'root'
})
export class CallEpisodePrescriptionService extends CommonService {

  constructor(private httpClient: HttpClient) {
    super();
  }

    public listEpisodePrescription(searchText: string, idPrescriptionStatus: number, idEpisode: number, idSector: number, idCareLinePriority: number, idSortingFilter: number): Observable<ListMedicalPrescriptionEpisodeResponse> {
    let uri = `CallEpisodePrescription/idPrescriptionStatus/${idPrescriptionStatus}?`;

    if (searchText) uri = uri + `searchText=${searchText}&`;

    if (idEpisode) uri = uri + `idEpisode=${idEpisode}&`;

    if (idSector) uri = uri + `idSector=${idSector}&`;

    if (idCareLinePriority) uri = uri + `idCareLinePriority=${idCareLinePriority}&`;
    if (idSortingFilter) uri = uri + `idSortingFilter=${idSortingFilter}&`;

    return this.httpClient.get<ListMedicalPrescriptionEpisodeResponse>(environment.urlApiOrchestratorPatient + uri, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public listEpisodePrescriptionByIdEpisode(idEpisode: number): Observable<EpisodePrescriptionToPharmacyPrescriptionReleaseResponse> {
    let uri = `CallEpisodePrescription/idEpisode/${idEpisode}`;

    return this.httpClient.get<EpisodePrescriptionToPharmacyPrescriptionReleaseResponse>(environment.urlApiOrchestratorPatient + uri, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public listPrescription(idEpisode: number): Observable<ListPharmacyPrescriptionResponse> {
    let uri = `CallEpisodePrescription/listPrescription/idEpisode/${idEpisode}`;

    return this.httpClient.get<ListPharmacyPrescriptionResponse>(environment.urlApiOrchestratorPatient + uri, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public liberatePrescription(liberatePrescriptionRequest: LiberatePrescriptionRequest): Observable<ListMedicalPrescriptionEpisodeResponse> {
    let uri = `CallEpisodePrescription`;

    return this.httpClient.post<ListMedicalPrescriptionEpisodeResponse>(environment.urlApiOrchestratorPatient + uri, liberatePrescriptionRequest, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public liberatePrescriptionSolution(liberateSolutionPrescriptionRequest: LiberateSolutionPrescriptionRequest): Observable<ListMedicalPrescriptionEpisodeResponse> {
    let uri = `CallEpisodePrescription/medicalPrescriptionSolution`;

    return this.httpClient.post<ListMedicalPrescriptionEpisodeResponse>(environment.urlApiOrchestratorPatient + uri, liberateSolutionPrescriptionRequest, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public getMedicationDispensingHistory(request: MedicationDispensingHistoryRequest): Observable<MedicationDispensingHistoryResponse> {
    let uri = `CallEpisodePrescription/getMedicationDispensingHistory`;

    return this.httpClient.post<MedicationDispensingHistoryResponse>(environment.urlApiOrchestratorPatient + uri, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public getMaterialDispensingHistory(request: MaterialDispensingHistoryRequest): Observable<MaterialDispensingHistoryResponse> {
    let uri = `CallEpisodePrescription/getMaterialDispensingHistory`;

    return this.httpClient.post<MaterialDispensingHistoryResponse>(environment.urlApiOrchestratorPatient + uri, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}